import React, { useState, useEffect } from "react";
import { Card, Select, Button, Row, Col, Typography, Space } from "antd";
import { BASE_URL } from "../../App";
import Swal from 'sweetalert2';
import { post } from "jquery";
import axios from 'axios';
import dayjs from "dayjs";
import  './css2.css';
import {  Backdrop,CircularProgress  } from '@mui/material';
import { Table,   Tag, Spin } from "antd";
const { Option } = Select;
const { Title } = Typography;

const ModernSelectForm = () => {
  const [branches, setBranches] = useState([]);
  const [branchValue, setBranchValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);
  const [open, setOpen] = useState(false);
  const [dates, setDates] = useState([]);
  const login_id = localStorage.getItem("LOGIN_ID");
  const branch = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");
  const [data, setData] = useState([]);

  const columns = [
    {
      title: "Branch Code",
      dataIndex: "BRANCH_CODE",
      key: "branch_code",
      render: (text) => text,
    },
    {
      title: "End Date",
      dataIndex: "END_DATE",
      key: "end_date",
      render: (text) => text,
    },
    {
      title: "Modified By",
      dataIndex: "MODIFIED_BY",
      key: "modified_by",
      render: (text) => text,
    },
    {
      title: "Modified On",
      dataIndex: "MODIFIED_ON",
      key: "modified_on",
      render: (text) => dayjs(text, "DD-MMM-YYYY").format("DD MMM YYYY"),
    },
  ];
  useEffect(() => {
    const fetbranch = async () => {
      try {
        setOpen(true);
        
        const response = await axios.post(`${BASE_URL}/getbranchforreport`, {
          login_id: login_id, branch_code: branch 
        });

        if (response.status === 200) {
            setOpen(false);
         
            setBranches(response.data.Branchlist || []);
            console.log('aaaa',branches);
        } else {
            setOpen(false);
          console.error('Invalid status code in the response');
        }
      } catch (error) {
        setOpen(false);
        console.error('Error fetching dealer codes:', error);
      }
    };

    fetbranch();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setOpen(true);
        
        const response = await axios.post(`${BASE_URL}/mpo_data`, {
          login_id: login_id, branch_code: branchValue 
        });

        if (response.status === 200) {
            setOpen(false);
         
            setData(response.data.mpodata || []);
            console.log('aaaa',branches);
        } else {
            setOpen(false);
          console.error('Invalid status code in the response');
        }
      } catch (error) {
        setOpen(false);
        console.error('Error fetching dealer codes:', error);
      }
    };

    fetchData();
  }, [branchValue]);
  const fetchData1 = async () => {
    try {
      setOpen(true);
      
      const response = await axios.post(`${BASE_URL}/mpo_data`, {
        login_id: login_id, branch_code: branchValue 
      });

      if (response.status === 200) {
          setOpen(false);
       
          setData(response.data.mpodata || []);
          console.log('aaaa',branches);
      } else {
          setOpen(false);
        console.error('Invalid status code in the response');
      }
    } catch (error) {
      setOpen(false);
      console.error('Error fetching dealer codes:', error);
    }
  };

  useEffect(() => {
    // Generate date-wise options for the current month
    const generateDates = () => {
      const currentMonth = dayjs().month() + 1;
      const currentYear = dayjs().year();
      const startOfMonth = dayjs(`${currentYear}-${currentMonth}-01`);
      const endOfMonth = startOfMonth.endOf("month");
      const datesArray = [];

      for (let d = startOfMonth; d.isBefore(endOfMonth) || d.isSame(endOfMonth); d = d.add(1, "day")) {
        datesArray.push({
          value: d.format("YYYY-MM-DD"),
          label: d.format("DD-MMM-YYYY"),
        });
      }
      setDates(datesArray);
    };
    generateDates();
  }, []);

  const handleSave = async () => {
    if (!branchValue ) {
        Swal.fire({
            icon: "infor",
            text: 'Select Branch',
            confirmButtonText: "Okay",
          });
      return;
    }
    if (!endDateValue ) {
        Swal.fire({
            icon: "infor",
            text: 'Select Date',
            confirmButtonText: "Okay",
          });
      return;
    }
    try {
        setOpen(true);
      const response = await axios.post(BASE_URL+'/mpo_config_update', {
        login_id,
        branch_code: branchValue,
        end_date: dayjs(endDateValue).format("DD"),
      });

      if (response.status === 200) {
        setOpen(false);
        if (response.data.status_code === 200) {
            setOpen(false);
            fetchData1 ();
            // setBranchValue(null);
            // setEndDateValue(null);
          Swal.fire({
            icon: "success",
            text: response.data.message,
            confirmButtonText: "Okay",
          });
        } else if (response.data.status_code === 400) {
            setOpen(false);
          Swal.fire({
            icon: "info",
            text: response.data.message,
            confirmButtonText: "Okay",
          });
        }
      } else {
        setOpen(false);
        Swal.fire({
          icon: "info",
          text: "End Date is not Updated, Please Try Again after Some Time!",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
        setOpen(false);
      Swal.fire({
        icon: "info",
        text: "End Date is not Updated, Please Try Again after Some Time!",
        confirmButtonText: "Okay",
      });
      console.error("Error updating MPO End Date:", error);
    }
  };

  return (
    <Card
      style={{
        maxWidth: 1200,
        margin: "auto",
        padding: 24,
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
      }}
    >
      <Title level={4} style={{ marginBottom: 20 }}>
        {/* Select Your Options */}
      </Title>
      <Row gutter={16}>
        <Col span={12}>
          <Typography.Text strong>Branch</Typography.Text>
          <Select
            style={{ width: "100%", marginTop: 4 }}
            placeholder="Select Branch"
            onChange={setBranchValue}
          >
            {usertype==="1" &&(
               <Option key="kett" value="ALL">
              ALL
               </Option>
            )}
            

            {branches.map((branch) => (
              <Option key={branch.branch} value={branch.branch}>
              {`${branch.branch}-${branch.branch_name}`}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={12}>
          <Typography.Text strong>End Date</Typography.Text>
          <Select
            style={{ width: "100%", marginTop: 4 }}
            placeholder="Select Date"
            onChange={setEndDateValue}
          >
            {dates.map((date) => (
              <Option key={date.value} value={date.value}>
                {date.label}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Space style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
        <Button type="primary" shape="round" size="large" onClick={handleSave}>
          Save
        </Button>
      </Space>
      {/* <Title level={3} style={{ textAlign: "center", color: "#2c3e50" }}>
      🌟 MPO Data Table 🌟
    </Title> */}
<br/>
{/* <br/> */}
<Card className="table-card">
<Table
          columns={columns}
          dataSource={data.map((item, index) => ({ ...item, key: index }))}
          bordered
          size="middle"
          className="modern-table"
        />
        </Card>
    
      <div>
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
    <CircularProgress color="inherit" />
  </Backdrop>
  </div>
    </Card>
  //   <Card
  //   style={{
  //     maxWidth: 900,
  //     margin: "auto",
  //     padding: 24,
  //     borderRadius: 16,
  //     boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
  //     background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
  //   }}
  // >
   
  // </Card>
   
  );
};

export default ModernSelectForm;
